import React, { useEffect, useState } from "react";
import styled from "styled-components";
import variables from "../../../constants/assets/variables";
import { FlexContainer } from "../../../constants/assets/containers";
import BlankState from "../../Common/BlankState";
import { CallMic, YoutubeFill, CameraFill } from "sushiweb/Icons";
import { red } from "sushiweb/tokens/color";
import {filterKeys, isValNull} from "../../../utils";

const CampaignList = (props) => {
  const { campaignList, handleViewDetails, handleDisable } = props;
  const excludedKeys = ["Is Active:"];

  const getCampaignDetail = (campaign, index) => {
    let mediaComponent = null;
    const filteredRowData = filterKeys(campaign.row_data, excludedKeys);
    if (campaign.media_type) {
      switch (campaign.media_type) {
        case "AUDIO":
          mediaComponent = (
            <MediaComponent>
              <CallMic color={red.z500} size={25} />
            </MediaComponent>
          );
          break;
        case "VIDEO":
          mediaComponent = (
            <MediaComponent>
              <YoutubeFill color={red.z500} size={25} />
            </MediaComponent>
          );
          break;
        case "IMAGE":
          mediaComponent = (
            <MediaComponent>
              <CameraFill color={red.z500} size={25} />
            </MediaComponent>
          );
          break;
      }
    }

    return (
      <CampaignCard align="flex-start">
        <CampaignCard.LeftSection>
          <CampaignDetail>
            {campaign.title && (
                <div className="title-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                  <h3
                      className="text-18"
                      onClick={() => {
                        handleViewDetails(campaign.campaign_id);
                      }}
                      style={{ marginRight: '8px' }}
                  >
                    {campaign.title}
                  </h3>
                </div>
            )}
            {!isValNull(filteredRowData) ? (
                filteredRowData.map((data) => {
                let message = `${data.key} ${data.value}`;
                return <p>{message}</p>;
              })
            ) : (
              <BlankState />
            )}
          </CampaignDetail>
        </CampaignCard.LeftSection>
        {mediaComponent}
          <CampaignCard.RightSection>
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
              {campaign.row_data[2]?.value === "true" && new Date(campaign.row_data[1]?.value.replace("IST", "GMT+0530")) - new Date() >= 300000 && (
                  <span
                      data-testid={`cancel${index}`}
                      onClick={() => handleDisable(campaign.campaign_id)}
                      style={{
                        marginRight: '10px',
                      }}
                  >
              Cancel
             </span>
              )}

              <span
                  data-testid={`view${index}`}
                  onClick={() => handleViewDetails(campaign.campaign_id)}
              >
              View
             </span>
            </div>
          </CampaignCard.RightSection>

      </CampaignCard>
    );
  };

    return (
        <CampaignListContainer data-testid="campaignListContainer">
            {!isValNull(campaignList) ? (
                campaignList.map((campaign, index) => {
                    return getCampaignDetail(campaign, index);
        })
      ) : (
        <BlankState />
      )}
    </CampaignListContainer>
  );
};

const CampaignListContainer = styled.div`
  border: 0.5px solid ${variables.borderColor};
  box-sizing: border-box;
  border-radius: 0.5rem;
`;

const MediaComponent = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-right: 3.5rem;
  margin-top: 1rem;
`;

const CampaignCard = styled(FlexContainer)`
  padding: 1.5rem;
  border-bottom: 1px solid ${variables.borderColor};
`;

CampaignCard.LeftSection = styled(FlexContainer)`
  img {
    width: 5rem;
    height: 5rem;
    border: 0.5px solid ${variables.borderColor};
    box-sizing: border-box;
    border-radius: 0.5rem;
    object-fit: cover;
  }
`;

CampaignCard.RightSection = styled(FlexContainer)`
  margin-top: 1rem;
  span {
    color: ${variables.buttonColor};
    font-weight: 500;
    cursor: pointer;
  }
`;

const CampaignDetail = styled.div`
  h3 {
    margin: unset;
    margin-bottom: 0.25rem;
    font-weight: 500;
    cursor: pointer;
  }
  p {
    color: #828282;
    font-size: 1rem;
    line-height: 1.4;
  }
`;

export default CampaignList;
